module.exports = __WEBPACK_EXTERNAL_MODULE_152__;


//////////////////
// WEBPACK FOOTER
// external "weaPortalPublic"
// module id = 152
// module chunks = 21 22